.account-header {
  display: flex;
  align-items: center;
  background-color: #ced4da;
  line-height: 1;
  padding: 16px;
  text-align: left;
  font-size: 14px;
  border-radius: 8px;
  padding-right: 20px;
}

.account-header-item {
  flex: 1;
}

.account-header-item:first-child {
  width: 55%;
  max-width: 55%;
}

.account-header-item:last-child {
  width: 32px;
  max-width: 32px;
  flex-basis: 32px;
  text-align: center;
}

.account-list {
  width: 100%;
  min-height: 300px;
  position: relative;
}

.account-row {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
}

.account-row:hover {
  background-color: #f5f5f5;
}

.address-row-item-data {
  font-size: 14px;
  line-height: 1;
  flex: 1;
  text-align: left;
  display: flex;
  align-items: center;
  padding-right: 16px;
}
.address-row-item-data:last-child {
  width: 32px;
  max-width: 32px;
  flex-basis: 32px;
  text-align: center;
  justify-content: center;
  padding-right: 0;
}

.navigation {
  display: flex;
  justify-content: center;
  gap: 10rem;
  margin-top: 20px;
}

.navigation-button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.navigation-button:hover {
  color: #1a56db;
}
.navigation-button:disabled {
  color: #737373;
  pointer-events: none;
}

.access-button {
  display: block;
  width: 200px;
  margin: 20px auto;
  padding: 12px;
  background-color: #1a56db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.access-button:disabled {
  background-color: #a1a1a1;
  color: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: none;
  transform: none;
}

.connection-link {
  display: flex;
  justify-content: center;
}

.ledger-confirm-address {
  text-align: center;
  padding: 48px 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media (min-width: 768px) {
  .ledger-confirm-address {
    padding: 48px 40px;
  }
}

.ledger-confirm-address-heading {
  font-weight: 500;
  font-size: 24px;
  line-height: 1;
  margin-bottom: 12px;
}

.ledger-confirm-address-section {
  line-height: 1.5;
  margin-top: 40px;
  font-size: 16px;
  text-align: center;
}

.ledger-confirm-address-section .ledger-confirm-address-description {
  color: #858688;
}

.ledger-confirm-address-section .ledger-confirm-address-data {
  background-color: #ced4da;
  line-height: 1;
  padding: 12px;
  text-align: center;
  border-radius: 8px;
}

.ledger-confirm-address-section .ledger-confirm-address-header {
  background-color: #ced4da;
  line-height: 1;
  padding: 12px;
  text-align: center;
  border-radius: 8px;
}

.ledger-confirm-address-footer {
  font-size: 14px;
  color: var(--gray-700);
  line-height: 1.5;
  position: relative;
  margin-top: 40px;
  padding-top: 40px;
}

.ledger-confirm-address-footer::before {
  height: 1px;
  content: '';
  left: 0;
  bottom: 100%;
  right: 0;
  position: absolute;
  background-color: var(--gray-700);
}

.ledger-confirm-address-footer a {
  color: var(--primary);
}
